import $https from '@/plugins/axios'

let state = {
  operationList: null
}

const getters = {
  operationList: state => {
    return state.operationList
  }
}

const mutations = {
  SET_OPERATION_LIST: (state, operationList) => {
    state.operationList = operationList
  }
}

const actions = {
  async GetOperationList ({ commit }) {
    const responseData = await $https.axios({ method: 'get', url: 'button/list' })
    commit('SET_OPERATION_LIST', responseData.data)
    return responseData.data
  },
  ClearOperationList ({ commit }) {
    commit('SET_OPERATION_LIST', null)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/operation.js